import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        const pageTitles = {
            "/dashboard": "Dashboard - CosmeticIQ",
            "/report-builder": "Report Builder - CosmeticIQ",
            "/new-products": "New Products - CosmeticIQ",
            "/most-searched": "Most Searched - CosmeticIQ",
            "/account": "Account - CosmeticIQ",
            "/reach-out": "Reach Out - CosmeticIQ",
            "/login": "Login - CosmeticIQ",
        };

        document.title = pageTitles[location.pathname] || "CosmeticIQ";
    }, [location.pathname]);

    return null; // This component doesn't render anything
};

export default PageTitleUpdater;
